import { types, flow, Instance } from 'mobx-state-tree';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import Common from '@store/common';
import { Partner } from '@constants/paymentLink';
import endpoints from '@configs/endpoints';
import axios from 'axios';

let stripeInstance: Stripe | null = null;

export interface FormPayload {
  cardNumber: string; // This will be the token ID
  cardHolderName: string;
  payeeFirstName: string;
  payeeLastName: string;
  payeeEmail: string;
  payeePhone: string;
  bin: string;
  last4: string;
}

export interface Confirm3dsPaymentStatusPayload {
  transactionId: string;
  partner: string;
}

const StripeStore = types
  .compose(
    Common,
    types.model({
      isProcessing: types.optional(types.boolean, false),
      errorMessage: types.optional(types.string, ''),
    }),
  )
  .actions((self) => ({
    setErrorMessage(message: string) {
      self.errorMessage = message;
    },
    setIsProcessing(value: boolean) {
      self.isProcessing = value;
    },
  }))
  .actions((self) => ({
    initializeStripe: flow(function* () {
      if (!stripeInstance) {
        stripeInstance = yield loadStripe(
          self.globalStore.links.paymentConfig.paymentMethods.card.publicApiKey,
        );
      }
      return stripeInstance;
    }),
    pay: flow(function* (params: FormPayload & { paymentLinkId: string }) {
      self.setErrorMessage('');

      try {
        // Prepare card info for the payload
        const cardInfo = {
          holderName: params.cardHolderName,
          bin: params.bin,
          last4: params.last4,
        };

        // Construct payload for backend
        const payload = {
          paymentLinkId: params.paymentLinkId,
          partner: Partner.STRIPE,
          token: params.cardNumber, // This is actually the Stripe token
          cardInfo,
          payeeFirstName: params.payeeFirstName,
          payeeLastName: params.payeeLastName,
          payeeEmail: params.payeeEmail,
          payeePhone: params.payeePhone,
          confirmationUrl: window.location.origin + window.location.pathname,
        };

        const { isSubscription } = self.globalStore.links.paymentLink;

        // Process payment or subscription with backend
        const { data } = yield axios.post(
          !isSubscription ? endpoints.processCardPayment : endpoints.processCardSubscription,
          payload,
        );

        const { metadata, success } = data;
        return { success, metadata };
      } catch (error: any) {
        console.log(error);
        throw error;
      } finally {
        // self.setIsProcessing(false);
      }
    }),
    confirm3dsPaymentStatus: flow(function* (parameters: Confirm3dsPaymentStatusPayload) {
      try {
        const { data } = yield axios.post(endpoints.confirm3dsPaymentStatus, parameters);
        return data;
        // eslint-disable-next-line no-useless-catch
      } catch (error: any) {
        console.log(error);
        throw error;
        // setIsRequesting(false);
      }
    }),
  }));

export type IStripeStore = Instance<typeof StripeStore>;
export default StripeStore;
